export default __webpack_public_path__ + "images/Mongolian.e072c4.jpg";